import { parsePhoneNumberFromString, type CountryCode } from "libphonenumber-js/min";

export const formatPhoneNumber = (
    phoneNumber?: string | null,
    countryCode?: string | null,
): string => {
    if (!phoneNumber) return "";

    const parsed = parsePhoneNumberFromString(
        phoneNumber,
        countryCode ? (countryCode.toUpperCase() as CountryCode) : undefined,
    );

    if (!parsed) return phoneNumber;

    return parsed.formatInternational();
};
